import { DateInput, Input, Label, Select } from "components";
import moment from "moment";
import { useHandleAuth } from "utils";

type FilterType = {
    period_type: number,
    month: number,
    year: number,
    date: string
}

export function FilterSection(props: {
    selected: FilterType,
    setSelected: (data: FilterType) => void
}) {

    const { userTokenData } = useHandleAuth()
      const userToken = userTokenData()


    const month = [
        { value: "1", label: "JANUARY" },
        { value: "2", label: "FEBRUARY" },
        { value: "3", label: "MARCH" },
        { value: "4", label: "APRIL" },
        { value: "5", label: "MAY" },
        { value: "6", label: "JUNE" },
        { value: "7", label: "JULY" },
        { value: "8", label: "AUGUST" },
        { value: "9", label: "SEPTEMBER" },
        { value: "10", label: "OCTOBER" },
        { value: "11", label: "NOVEMBER" },
        { value: "12", label: "DECEMBER" }
    ];

    const depreciationPeriode = [
        { value: "1", label: "MONTH" },
        { value: "2", label: "YEAR" }
    ]


    return (
        <>
            <div className="flex flex-col gap-2 w-full">
                <div className="lg:flex justify-between items-start">
                    <div>
                        <div className="flex gap-2 items-center">
                            <Label className="w-[170px]">DEPRECIATION PERIOD</Label>
                            <span>:</span>
                            <Select
                                options={depreciationPeriode}
                                value={depreciationPeriode.find(item => item.value === props?.selected?.period_type?.toString())}
                                onChange={e => props.setSelected({ ...props.selected, period_type: Number(e?.value) }) }
                                className="lg:w-[250px]"
                            />
                        </div>
                        <div className="flex gap-2 items-center">
                            <Label className="w-[170px]">DEPRECIATION METHOD</Label>
                            <span>:</span>
                            <div className="font-bold">STRAIGHT-LINE METHOD</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <Label className="w-[170px] lg:w-[30px]">DATE</Label>
                        <span>:</span>
                        <DateInput
                            onChange={(e) => props.setSelected({ ...props.selected, date: moment(e).format("YYYY-MM-DD") })}
                            selected={moment(props.selected.date).toDate()}
                        />
                    </div>
                </div>
                <div className="lg:flex gap-4 items-center justify-between">
                    <div className="flex gap-2 items-center lg:mb-0">
                        <Label className="w-[170px]">PERIODE </Label>
                        <span>:</span>
                        <Select
                            value={month.find(item => Number(item.value) === props.selected.month)}
                            onChange={e => props.setSelected({ ...props.selected, month: Number(e?.value) })}
                            options={month}
                            isDisabled={props.selected.period_type === 2}
                        />
                        <DateInput
                            onChange={(year) => year && props.setSelected({ ...props.selected, year: year.getFullYear() })}
                            showYearPicker
                            dateFormat={"yyyy"}
                            selected={props.selected.year ? new Date(props.selected.year, 0, 1) : new Date()}
                        />
                    </div>
                    <div className="flex gap-2 items-center mb-2 lg:mb-0">
                        <Label className="w-[170px] lg:w-[60px]">COMPANY</Label>
                        <span>:</span>
                        <Input 
                            placeholder="Input Code" 
                            value={userToken?.employee_name}
                            disabled
                        />
                    </div>
                </div>


            </div>
        </>
    );
}